<script setup lang="ts">
import { computed } from 'vue'
import { Clock3 } from 'lucide-vue-next'
import { elapsedLayoutWidth } from '@/ui/widget-elapsed'
const props = defineProps<{ elapsed: string; label: string; compact?: boolean }>()
const description = computed(() => `${props.label} ${props.elapsed}`)
</script>

<template>
  <span class="widget-elapsed" :class="{ 'is-compact': compact }" data-widget-elapsed data-stream-measure :title="description" :aria-label="description">
    <Clock3 aria-hidden="true" /><span class="widget-elapsed-label">{{ label }}</span><b :style="{ minWidth: `${elapsedLayoutWidth(elapsed)}ch` }">{{ elapsed }}</b>
  </span>
</template>
